<template>  
    <div :style="shu.yangshi" class="zidingyi_Sousuo">
		<span class="tubiao tb-sousuo"></span>
		<input type="text" placeholder="请输入搜索内容" class="zidingyi_Sousuo_input">
	</div> 	
</template>

<script>
export default {
  name: 'wenzi',
  props: {
       shu: {
		   type:Object,
		   default(){
			   return {wenzi:'输入文字',yangshi:{}}
		   }
		}
  },
  
}

</script>


